import React from 'react';

import { usePrincipalUser, type UserStatus } from '@atlassian/ptc-common';

import { DEFAULT_CARDS_SIZE, ProfilePlaces } from '../ProfilePlaces';

import useContainersQuery from './useContainersQuery';

interface Props {
	userId: string;
	status: `${UserStatus}`;
	userFullName: string;
}

function ContainersInProfilePage(props: Props) {
	const { userId, status, userFullName } = props;
	const [{ principalUserId }] = usePrincipalUser();
	const { error, hasError, data, loading } = useContainersQuery({
		userId,
		maxNumberOfCards: DEFAULT_CARDS_SIZE,
	});

	return (
		<ProfilePlaces
			hasLoaded={!!data && !loading}
			isCurrentUser={principalUserId === userId}
			userStatus={status}
			hasError={hasError}
			error={error}
			items={data}
			userId={userId}
			userFullName={userFullName}
		/>
	);
}

export default ContainersInProfilePage;
